import { createContext, useContext } from "react";
import {
  resolveRuntimeMessenger,
  type RuntimeMessengerSnapshot,
} from "@/shared/utils/runtimeMessenger";

export const RuntimeMessengerContext =
  createContext<RuntimeMessengerSnapshot | null>(null);

export function useRuntimeMessenger(): RuntimeMessengerSnapshot {
  const ctx = useContext(RuntimeMessengerContext);
  if (!ctx) {
    if (typeof window !== "undefined") {
      return resolveRuntimeMessenger();
    }
    return {
      kind: "web",
      userId: null,
      telegramUser: null,
      maxUser: null,
      source: "no-provider",
    };
  }
  return ctx;
}
